
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/didattica/[slug]/risorse",
      function () {
        return require("private-next-pages/didattica/[slug]/risorse.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/didattica/[slug]/risorse"])
      });
    }
  